import React,{useEffect} from 'react'
import AdminForm from '../components/Form/AdminForm'

export default function AdminPage() {

    return (
        <AdminForm />
    )
}
